const mutations = {
    add(state, object) {
        state.itens.push(object);
    },
    setList(state, list) {
        state.itens = list;
    },
    setObject(state, object) {
        state.item = object;
        if (object.city != null && object.city.state != null) {
            state.item.city = object.city
        } else {
            state.item.city = {
                id: '',
                name: '',
                state: {
                    id: '',
                    name: ''
                }
            }
        }
    },
    delObject(state, object) {
        state.itens.splice(state.itens.indexOf(object), 1);
    }
};

export default mutations;